/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_AddInputs */

const cs_gallery_add = /** @type {(inputs: Gallery_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat fotky`)
};

const en_gallery_add = /** @type {(inputs: Gallery_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add photos`)
};

/**
* | output |
* | --- |
* | "Add photos" |
*
* @param {Gallery_AddInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_add = /** @type {((inputs?: Gallery_AddInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_AddInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_add(inputs)
	return cs_gallery_add(inputs)
});